import React, {createContext, useReducer} from 'react'
import {AssociateFilterReducer} from "../reducers/AssociateFilterReducer";

export const AssociateFilterContext = createContext();

const AssociateFilterContextProvider = (props) => {
    const [ states, dispatch ] = useReducer(AssociateFilterReducer, []);
    return (
        <AssociateFilterContext.Provider value = {{states, dispatch}}>
            {props.children}
        </AssociateFilterContext.Provider>
    )
}

export default AssociateFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/associate/context/AssociateFilterContext.js